import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ContractVehicles from '../views/ContractVehicles.vue'
import ApplicationModernization from '../views/Capabilities/ApplicationModernization.vue'
import BusinessIntelligence from '../views/Capabilities/BusinessIntelligence.vue'
import CloudCapability from '../views/Capabilities/CloudCapability.vue'
import CyberSecurity  from '../views/Capabilities/CyberSecurity.vue'
import DevSecOps  from '../views/Capabilities/DevSecOps.vue'
import DigitalServices  from '../views/Capabilities/DigitalServices.vue'
import HealthItServices from '../views/Capabilities/HealthItServices.vue'
import NationalSecurityServices from '../views/Capabilities/NationalSecurityServices.vue'
import ProgramManagement from '../views/Capabilities/ProgramManagement.vue'
import ComplySyncATO from '../views/Solutions/ComplySyncATO.vue'
import AboutUs from '../views/AboutUs.vue'
import ContactUs from '../views/ContactUs.vue'
import TermsOfUse from '@/views/TermsOfUse.vue'; 
import PrivacyStatement from '@/views/PrivacyStatement.vue'; 
import AccessibilityView from '@/views/AccessibilityView.vue'; 
const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/contract-vehicles',
    name: 'contract-vehicles',
    component: ContractVehicles
  },
  {
    path: '/capabilities/application-modernization',
    name: 'application-modernization',
    component: ApplicationModernization
  },
  {
    path: '/capabilities/business-intelligence',
    name: 'business-intelligence',
    component: BusinessIntelligence
  },
  {
    path: '/capabilities/cloud',
    name: 'cloud',
    component: CloudCapability
  },
  {
    path: '/capabilities/cyber-security',
    name: 'cyber-security',
    component: CyberSecurity
  },
  {
    path: '/capabilities/devsecops',
    name: 'devsecops',
    component: DevSecOps
  },
  {
    path: '/capabilities/digital-services',
    name: 'digital-services',
    component: DigitalServices
  },
  {
    path: '/capabilities/health-it-services',
    name: 'health-it-services',
    component: HealthItServices
  },
  {
    path: '/capabilities/national-security-services',
    name: 'national-security-services',
    component: NationalSecurityServices
  },
  {
    path: '/capabilities/program-management',
    name: 'program-management',
    component: ProgramManagement
  },
  {
    path: '/solutions/complySync-ato',
    name: 'complySync-ato',
    component: ComplySyncATO
  },
  {
    path: '/about-us',
    name: 'about-us',
    component:AboutUs
  },
  {
    path: '/contact-us',
    name: 'contact-us',
    component:ContactUs
  },
  {
    path: '/terms-of-use',
    name: 'TermsOfUse',
    component: TermsOfUse,
  },
  {
    path: '/privacy-statement',
    name: 'PrivacyStatement',
    component: PrivacyStatement,
  },
  {
    path: '/accessibility',
    name: 'accessibility',
    component: AccessibilityView,
  },
  {
    path: '/sectors/banking-and-finance',
    name: 'banking-and-finance',
    component: () => import('../views/Sectors/BankingAndFinance.vue')
  },
  {
    path: '/sectors/federal-civilian',
    name: 'federal-civilian',
    component: () => import('../views/Sectors/FederalCivilian.vue')
  },
  {
    path: '/sectors/health-care',
    name: 'health-care',
    component: () => import('../views/Sectors/HealthCare.vue')
  },
  {
    path: '/sectors/national-security',
    name: 'national-security',
    component: () => import('../views/Sectors/NationalSecurity.vue')
  },
  {
    path: '/sectors/reg-tech',
    name: 'reg-tech',
    component: () => import('../views/Sectors/RegTech.vue')
  },
  {
    path: '/sectors/state-and-local-government',
    name: 'state-and-local-government',
    component: () => import('../views/Sectors/StateAndLocalGovernment.vue')
  },
  {
    path: '/solutions/debt-management',
    name: 'debt-management',
    component: () => import('../views/Solutions/DebtManagement.vue')
  },
  {
    path: '/solutions/security-data-lake',
    name: 'security-data-lake',
    component: () => import('../views/Solutions/SecurityDataLake.vue')
  },
  {
    path: '/solutions/test-automation-platform',
    name: 'test-automation-platform',
    component: () => import('../views/Solutions/TestAutomationPlatform.vue')
  },
  {
    path: '/solutions/hephaestus',
    name: 'hephaestus',
    component: () => import('../views/Solutions/HephaestusSolution.vue')
  },
  {
    path: '/mda-shield-idiq',
    name: 'CIO-SP3',
    component: () => import('../views/ContractVehicles/MdaShieldIdiq.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
